import axios from 'axios'
import applyCaseMiddleware from 'axios-case-converter'
import { State } from '@/socialPreview/types'
import { API_PATH, SYSTEM_ERROR } from '@/common/constants'
import { SocialPreviewType, ParentCategoryType } from '@/types'

const ENDPOINTS = {
  SOCIAL_PREVIEW: '/social_preview/%s/',
  CATEGORIES: '/categories/%s/'
}
export interface Store {
  state: State
  fetchSocialPreviewData: (displayId: string) => void
  fetchCategoryData: () => void
}

export const store: Store = {
  state: {
    displayId: null,
    socialPreview: null,
    childCategory: {
      section: null,
      items: []
    }
  },
  async fetchSocialPreviewData(displayId: string): Promise<void> {
    this.state.displayId = displayId

    const client = applyCaseMiddleware(axios.create())
    const { data } = await client.get<SocialPreviewType>(
      `${API_PATH}${ENDPOINTS.SOCIAL_PREVIEW.replace(/%s/, this.state.displayId)}`
    ).catch(error => {
      window.alert(SYSTEM_ERROR.UNKNOWN)
      throw new Error(error)
    })

    this.state = {
      ...this.state,
      socialPreview: data
    }
  },
  async fetchCategoryData(): Promise<void> {
    if (!this.state || !this.state.socialPreview || !this.state.socialPreview.rootCategoryId) return

    const client = applyCaseMiddleware(axios.create())

    const { data } = await client
      .get<ParentCategoryType>(
        `${API_PATH}${ENDPOINTS.CATEGORIES.replace(
          /%s/,
          this.state.socialPreview.rootCategoryId.toString()
        )}`
      )
      .catch(error => {
        throw new Error(error)
      })
      
    const { categorySections, childCategories } = data

    const childCategorySections = categorySections.filter(
      item => item.sectionType === 'child_category'
    )
    
    const childCategoriesSectionState = !childCategorySections.length
      ? null
      : {
          section: childCategorySections[0],
          items: childCategories
        }

    this.state = {
      ...this.state,
      childCategory: childCategoriesSectionState
    }
  }
}
